const glossary = {
	'button.default_text': 'Show in 3D',

	'widget.note_use': 'Insert sizes and press “Try”',
	'widget.title_size': 'Fitting on the dimensions of goods',
	'widget.title_model': 'Fitting of goods',
	'widget.depth': 'Depth',
	'widget.width': 'Width',
	'widget.height': 'Height',
	'widget.try': 'Try',
	'widget.btn_copy': 'Copy the link',
	'widget.btn_copy_2': 'Copied',
	'widget.share_text': 'Use the qr-code on your phone or copy the link to try on the dimensions of the item.',
	'widget.unsupported_text': 'Use a phone with Android OS 8.0+ and and ARCore 1.9+ support.',

	'unit.mm': 'mm',
	'unit.cm': 'cm',
	'unit.m': 'm',

	'error.not_loaded': 'Failed to get data. Please try again later.',
};

export default () => glossary;